<script setup>
import Multiselect from '@vueform/multiselect';
import { computed } from 'vue';

const props = defineProps({
  value: {
    type: Array,
    default() {
      return [];
    },
  },
  options: {
    type: Array,
    default() {
      return [];
    },
  },
  multipleLabel: {
    type: String,
    default: 'Кол-во:',
  },
  placeholder: {
    type: String,
    default: 'Все',
  },
  noOptionsText: {
    type: String,
    default: 'Список пуст'
  }
});
const emit = defineEmits(['update:value']);

const selectedItems = computed({
  get: () => props.value,
  set: (val) => emit('update:value', val),
});
</script>

<template>
  <Multiselect
    v-model="selectedItems"
    mode="multiple"
    :placeholder="placeholder"
    :options="options"
    :hide-selected="false"
    :close-on-select="false"
    :noOptionsText="noOptionsText"
    :multiple-label="n => `${multipleLabel} ${n.length}`"
  >
    <template #option="{ option, isSelected }">
      <input
        type="checkbox"
        class="checkbox__input"
        :checked="isSelected(option)"
      >
      <span class="checkbox__custom mr-2" />
      {{ option.label }}
    </template>
    <template #caret>
      <svg
        width="20"
        height="20"
        class="icon down_icon"
      >
        <use xlink:href="#down" />
      </svg>
    </template>
  </Multiselect>
</template>

<style lang="scss">
@import "@vueform/multiselect/themes/default.css";
@import "../../styles/utils/variables.scss";

.multiselect {
	max-width: 220px;
	min-width: 220px;
	--ms-placeholder-color: #49494F;
  border-radius: 50px;
  border: none;
  box-shadow: none;
  font-size: 14px;
  font-weight: 500;
  background-color: $smooth-gray;
  height: 52px;

	.down_icon {
		stroke: #49494F;
		width: 20px;
		background-color: inherit;
		transition: transform 0.3s;
		pointer-events: none;
    margin-right: 20px;
	}

	&.is-active {
    box-shadow: none;

		.down_icon {
			transform: rotate(-180deg);
		}
	}

  &.is-open {
    border-radius: 50px;
  }

	@media (max-width: $screen-md) {
		max-width: none;
    min-width: 150px;
    height: 40px;
	}
}

.multiselect-dropdown {
  bottom: -5px;
  max-height: 200px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: $border-radius;
  box-shadow: 0px 2px 10px 0px #f3f4f6;

  &::-webkit-scrollbar {
    width: 5px;
    border-radius: $border-radius;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $grey-light;
    border-radius: $border-radius;
  }

  z-index: 11;
}

.multiselect-option {
  padding: 4px 12px;
  font-size: 14px;
}

.multiselect-clear {
  padding: 0;
  margin-right: 14px;
}

.multiselect-placeholder {
  padding-left: 20px;
}
</style>
